import {
  GET_NEWS_DONE,
  GETTING_NEWS,
} from './constants';

export default {
  [GET_NEWS_DONE](state, payload) {
    state.news = payload;
  },
  [GETTING_NEWS](state, getting) {
    state.gettingNews = getting;
  },
};
